import React from "react";

const PageNumbers = ({
  currentPage,
  totalPages,
  handlePageChange,
  PAGINATION_RANGE = 2,
}) => {
  const renderPageNumbers = () => {
    const pageNumbers = [];
    let startPage = Math.max(1, currentPage - PAGINATION_RANGE);
    let endPage = Math.min(totalPages, currentPage + PAGINATION_RANGE);

    const showEllipsisLeft = currentPage - PAGINATION_RANGE > 2;
    const showEllipsisRight = currentPage + PAGINATION_RANGE < totalPages - 1;

    // Previous arrow button
    if (currentPage > 1) {
      pageNumbers.push(
        <button
          key="prev"
          style={{
            backgroundColor: "#CC0000",
            color: "white",
            fontWeight: "900",
          }}
          className="pagination-button"
          onClick={() => handlePageChange(currentPage - 1)}
        >
          ←
        </button>
      );
    }

    if (startPage > 1) {
      pageNumbers.push(
        <button
          className="pagination-button"
          key={1}
          onClick={() => handlePageChange(1)}
        >
          1
        </button>
      );
    }

    if (showEllipsisLeft) {
      pageNumbers.push(
        <span key="ellipsis-left" style={{ margin: "0px 24px" }}>
          ...
        </span>
      );
    }

    for (let page = startPage; page <= endPage; page++) {
      pageNumbers.push(
        <button
          key={page}
          onClick={() => handlePageChange(page)}
          className="pagination-button"
          style={
            currentPage === page ? { borderBottom: "1px solid #CC0000" } : {}
          }
        >
          {page}
        </button>
      );
    }

    if (showEllipsisRight) {
      pageNumbers.push(
        <span key="ellipsis-right" style={{ margin: "0px 24px" }}>
          ...
        </span>
      );
    }

    if (endPage < totalPages) {
      pageNumbers.push(
        <button
          className="pagination-button"
          key={totalPages}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </button>
      );
    }

    // Forward arrow button
    if (currentPage < totalPages) {
      pageNumbers.push(
        <button
          className="pagination-button"
          style={{
            backgroundColor: "#CC0000",
            color: "white",
            fontWeight: "900",
          }}
          key="next"
          onClick={() => handlePageChange(currentPage + 1)}
        >
          →
        </button>
      );
    }

    return pageNumbers;
  };

  return <div className="pagination-container">{renderPageNumbers()}</div>;
};

export default PageNumbers;
